<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Invoice status')"
          :description="$t('From Here You Can Control The Statuses Of Your Groups')"
        />
        <indexTable
          :searchText="$t('Search For a case')"
          :emptyTableText="$t('There are no cases')"
          :localData="true"
          :buttonRole="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            {
              column: 'name',
              title: $t('Status Name'),
              type: 'text',
              sort: true
            },
            {
              column: 'stat',
              title: $t('The Status'),
              type: 'stat',
              sort: true,
              hideMobile: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: true },
                { name: 'delete', role: true }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/invoiceStatus'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
